import { fetchAuthSession } from "@aws-amplify/auth";

export const getIdToken = async () => {
  const session = await fetchAuthSession();

  return session.tokens?.idToken;
};
